export default __webpack_public_path__ + "static/media/Conservation.8c3ca019.png";